import {
  availableDateFilters,
  getDateFilterTranslationKey,
} from 'components/Blotters/Filter/BlotterFilterNext.helpers';
import { DropdownWrapper, SpDropdownItem } from 'components/shared/Dropdown';
import { FC } from 'react';
import { DropdownMenu, DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import type { DateFilter as DateFilterType } from 'state/blotters/common/blotter.model';

interface DateFilterProps {
  value: DateFilterType;
  onChange: (value: DateFilterType) => void;
}

export const DateFilter: FC<DateFilterProps> = ({ value, onChange }) => {
  return (
    <DropdownWrapper openOnHover className="btn-group border-start border-opacity-40" data-e2e="date-filter">
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
      >
        <i className="icon">access_time</i>
        <span className="d-none d-xxl-inline-block">
          <FormattedMessage id={getDateFilterTranslationKey(value)} />
        </span>
      </DropdownToggle>
      <DropdownMenu role="listbox">
        {availableDateFilters(value).map(dateFilter => (
          <SpDropdownItem key={dateFilter} active={dateFilter === value} onClick={() => onChange(dateFilter)}>
            <FormattedMessage id={getDateFilterTranslationKey(dateFilter)} />
          </SpDropdownItem>
        ))}
      </DropdownMenu>
    </DropdownWrapper>
  );
};
